import { SelectedRegistryData } from '../dialogs/registryModal/RegistryModal.types'
import { SubTagModalFormValues } from '../dialogs/subTagsModal/SubTagsModal.types'

import { Validation } from '@percent/admin-dashboard/api/actions/admin/admin.types'

type DisableConfirmParams = {
  validation: Validation | undefined
  selectedRegistryData: SelectedRegistryData
  registryIdDoesNotMatchRegistryRegex: boolean
  relatedOrganisations: unknown[] | null
  relationshipFormType?: string
  relationshipFormErrors: Record<string, unknown>
  organisationTypeFormErrors: Record<string, unknown>
  isLoadingRelatedOrganisations: boolean
  similarOrganisations: unknown[] | null
  similarOrganisationFormAction?: string
  similarOrganisationFormErrors: Record<string, unknown>
  isLoadingSimilarOrganisations: boolean
  isOnlyEducationOrganisation: boolean
  subTagsFormErrors: Record<string, unknown>
  subTagsFormValues: SubTagModalFormValues
}

export function disableConfirm({
  validation,
  selectedRegistryData,
  registryIdDoesNotMatchRegistryRegex,
  relatedOrganisations,
  relationshipFormType,
  relationshipFormErrors,
  organisationTypeFormErrors,
  isLoadingRelatedOrganisations,
  similarOrganisations,
  similarOrganisationFormAction,
  similarOrganisationFormErrors,
  isLoadingSimilarOrganisations,
  isOnlyEducationOrganisation,
  subTagsFormErrors,
  subTagsFormValues
}: DisableConfirmParams): boolean {
  if (!validation) {
    return true
  }

  if (
    (!selectedRegistryData?.registryInformationNotFound && !selectedRegistryData?.registry.id) ||
    registryIdDoesNotMatchRegistryRegex
  ) {
    return true
  }

  if (relatedOrganisations?.length && !relationshipFormType) {
    return true
  }

  if (Object.keys(relationshipFormErrors).length) {
    return true
  }

  if (Object.keys(organisationTypeFormErrors).length) {
    return true
  }

  if (
    selectedRegistryData?.registry.id &&
    !selectedRegistryData?.registryInformationNotFound &&
    isLoadingRelatedOrganisations
  ) {
    return true
  }

  if (similarOrganisations?.length && !similarOrganisationFormAction) {
    return true
  }

  if (Object.keys(similarOrganisationFormErrors).length) {
    return true
  }

  if (selectedRegistryData?.registryInformationNotFound && isLoadingSimilarOrganisations) {
    return true
  }

  if (isOnlyEducationOrganisation) {
    if (Object.keys(subTagsFormErrors).length) {
      return true
    }

    if (
      !subTagsFormValues.insufficientInformation &&
      !subTagsFormValues.notEducation &&
      !subTagsFormValues.subTags.length
    ) {
      return true
    }
  }

  return false
}
